import React, { useEffect, useState } from 'react'
import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client'
import { getPowerBiEmbedToken } from '../util/powerBiUtil'

export default function PowerBIReportEmbed({ reportId, workspaceId, className }) {
  const [embedConfig, setEmbedConfig] = useState(null)

  useEffect(() => {
    async function fetchEmbedConfig() {
      const token = await getPowerBiEmbedToken(reportId, workspaceId)
      setEmbedConfig({
        type: 'report',
        id: reportId,
        embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${workspaceId}`,
        accessToken: token,
        tokenType: models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: false }
          },
          navContentPaneEnabled: false,
          background: models.BackgroundType.Transparent
        },
        pageView: 'fitToWidth'
      })
    }
    fetchEmbedConfig()
  }, [reportId, workspaceId])

  if (!embedConfig) return <div>Loading Power BI report...</div>

  return (
    <div>
      <PowerBIEmbed
        embedConfig={embedConfig}
        cssClassName={className || 'powerbi-report-embed'}
        getEmbeddedComponent={embeddedReport => {
          window.report = embeddedReport
        }}
      />
    </div>
  )
}
